// extracted by mini-css-extract-plugin
export var closeButton = "_1a-3";
export var header = "_1a-0";
export var link = "_1a-1";
export var retryButton = "_1a-2";